export enum Gamemode {
    Osu = 0,
    Taiko = 1,
    Catch = 2,
    Mania = 3
};